import { useAuth0 } from "@auth0/auth0-react";

// Single-flight: when the session dies, many hooks fail getToken() in
// parallel — only the first may start a login redirect, or the user gets a
// consent/login screen per concurrent request.
let loginRedirectStarted = false;

const useAuth = () => {
  // console.log("[cc] web useAuth");

  const {
    user,
    isAuthenticated,
    getAccessTokenSilently,
    loginWithRedirect,
    logout,
  } = useAuth0();

  const getToken = async () => {
    try {
      const token = await getAccessTokenSilently();
      return token;
    } catch (error: any) {
      console.error("Error getting access token", error);
      // Session is gone (expired token + no silent renewal) — send the user
      // back through login instead of letting callers fire requests with an
      // undefined token ("Bearer undefined" → jwt malformed 401s).
      const needsLogin = [
        "login_required",
        "consent_required",
        "missing_refresh_token",
        "invalid_grant",
      ].includes(error?.error);
      if (needsLogin && typeof window !== "undefined" && !loginRedirectStarted) {
        loginRedirectStarted = true;
        await loginWithRedirect({
          appState: { targetUrl: window.location.pathname },
        });
      }
      throw error;
    }
  };

  return {
    user,
    isAuthenticated,
    loginWithRedirect,
    logout,
    getToken,
  };
};

export { useAuth };
